import { Appointment, CalendarEventTypeEnum, Customer } from '../../types';

export function GetAppointmentCustomer(
  appointment: Omit<Appointment, 'duration' | 'status' | 'createdAt' | 'createdBy' | 'updatedAt' | 'id'>,
) {
  if (appointment.type && [CalendarEventTypeEnum.APPOINTMENT, CalendarEventTypeEnum.TASK].includes(appointment.type)) {
    return (appointment.eventTypeData as { customer?: Customer }).customer;
  }
}
